import React, { useState } from 'react';
import { apiUrl } from '../../UploadDocument/apiUrl';

const DicomSenderAll = ({ isOpen }) => {
  const [isTransferring, setIsTransferring] = useState(false);

  // 1. Clases de diseño adaptadas del Sidebar
  const commonButtonClass =
    'flex hover:bg-primary-main justify-start justify-items-center rounded p-1 w-full text-white my-2';

  // Clase para ocultar o mostrar el texto
  const textVisibilityClass = isOpen ? '' : 'hidden';

  // Color neutro/primario para la acción
  const buttonBgClass = isTransferring
    ? 'bg-gray-500 cursor-not-allowed'
    : 'bg-primary-main hover:bg-primary-dark';

  // Cálculo de las dimensiones dinámicas del icono: 25px abierto, 15px cerrado.
  const dynamicIconSize = isOpen ? '25' : '15';

  // Función para transferir estudios
  const handleTransfer = async () => {
    if (isTransferring) return;

    try {
      setIsTransferring(true);
      const response = await fetch(apiUrl + '/api/dicom/transfer-study', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        alert('Transferencia de estudios iniciada correctamente.');
      } else {
        const errorData = await response.json();
        console.error('Error al transferir estudios:', errorData);
        alert('Error al iniciar la transferencia: ' + (errorData.message || response.statusText));
      }
    } catch (error) {
      console.error('Error al enviar la solicitud de transferencia:', error);
      alert('Error de red al intentar transferir estudios.');
    } finally {
      setIsTransferring(false);
    }
  };

  return (
    <button
      onClick={handleTransfer}
      disabled={isTransferring}
      className={`${commonButtonClass} ${buttonBgClass} transition-colors duration-200 my-2`}
      title="Transferir todos los estudios al PACS externo"
    >
      {/* Icono dinámico: Spinner si está transfiriendo, avión de papel si no */}
      {isTransferring ? (
        <svg
          className="animate-spin text-white flex-shrink-0"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          width={dynamicIconSize}
          height={dynamicIconSize}
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={dynamicIconSize}
          height={dynamicIconSize}
          className="text-white flex-shrink-0"
          viewBox="0 0 16 16"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M15.854.146a.5.5 0 0 1 .11.54l-2.8 7a.5.5 0 1 1-.928-.372l1.895-4.738-7.494 7.494 1.376 2.162a.5.5 0 1 1-.844.537l-1.531-2.407L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM5.93 9.363l7.494-7.494L1.591 6.602z"
          />
          <path
            fillRule="evenodd"
            d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354a.5.5 0 0 0-.722.016l-1.149 1.25a.5.5 0 1 0 .737.676l.28-.305V14a.5.5 0 0 0 1 0v-1.793l.396.397a.5.5 0 0 0 .708-.708z"
          />
        </svg>
      )}

      {/* Texto - visible solo si el sidebar está abierto */}
      <span className={`ml-3 whitespace-nowrap overflow-hidden ${textVisibilityClass}`}>
        {isTransferring ? 'Cargando...' : 'Transferir estudios'}
      </span>
    </button>
  );
};

export default DicomSenderAll;
